import SolutionCard from "../../reusables/SolutionCard";
import lab from "../../../assets/images/solutions-icon/ict_lab.svg";

const ICTConsultancySolution = () => {
  return (
    <SolutionCard
      icon={lab}
      title="ICT Consultancy & Setup"
      subtitle="Expert guidance on technology implementation and Office & School Computer Lab ICT setup"
      ctaLink="/solutions/ict-consultancy"
    />
  );
};

export default ICTConsultancySolution;
